exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-popper.append-to-body{z-index:1060}.fts-popper:not(.append-to-body){z-index:1000}.popper-content{max-height:100%;max-width:100%;padding:.375rem 0;box-shadow:var(--fts-elevation-3);border-radius:.25rem;background:var(--fts-popover-background);color:var(--fts-text);font-size:.875rem}", ""]);

// exports
